<script>
    import { Typography } from '../UI'
    export let title = ''
</script>

<div>
    <Typography style="width: 100%" color="black" type="h4">{title}</Typography>
    <slot />
</div>

<style>
    div {
        position: relative;
        width: 100%;
        display: flex;
        flex-direction: column;
        gap: 0;
    }
</style>
